import { rgba } from 'polished';
import { ColorScheme } from 'shared/assets/styles';
import { typographyToCss } from 'shared/lib/mui';
import { QueryNavLink } from 'shared/lib/react-router-dom';
import styled, { css } from 'styled-components';

export const Link = styled(QueryNavLink)<{
  $active: boolean;
  $isMoving: boolean;
}>`
  ${({ theme }) => typographyToCss(theme.typography.body2)};
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};

  padding: ${({ theme }) => `${theme.spacing(1.5)} ${theme.spacing(3)}`};

  border-radius: ${({ theme }) => theme.spacing(2.5)};
  transition:
    background 200ms,
    color 200ms;

  text-decoration: none;
  color: ${({ theme }) =>
    rgba(
      theme.palette.text.primary,
      theme.colorScheme === ColorScheme.Dark ? 0.6 : 0.8,
    )};

  ${({ $active }) =>
    $active
      ? css`
          ${({ theme }) => typographyToCss(theme.typography.subtitle2)};
          background: ${({ theme }) => rgba(theme.palette.text.primary, 0.06)};
          color: ${({ theme }) => theme.palette.text.primary};

          &:focus {
            background: ${({ theme }) =>
              rgba(theme.palette.text.primary, 0.06)};
            color: ${({ theme }) => theme.palette.text.primary};
          }
        `
      : css`
          &:hover {
            background: ${({ theme }) =>
              rgba(theme.palette.text.primary, 0.06)};
          }
        `};

  ${({ theme, $isMoving }) =>
    $isMoving &&
    css`
      background: ${theme.palette.background.default};

      &:hover {
        background: ${theme.palette.background.default};
      }
    `};
`;

export const IconContainer = styled.span<{ $color: string }>`
  font-size: 1.6rem;
  line-height: 62.5%;
  color: ${({ $color }) => ($color ? $color : 'inherit')};
`;

export const Title = styled.span`
  display: block;
  flex: 1;

  overflow: hidden;

  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const IconButtonContainer = styled.span`
  width: 0;
  opacity: 0;
  margin-left: 0;
  overflow: hidden;

  transition:
    width 200ms,
    opacity 200ms,
    margin-left 200ms;

  ${Link}:hover & {
    width: 2.2rem;
    opacity: 1;
    margin-left: ${({ theme }) => theme.spacing(1)};
  }
`;
